/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronDown: {
  name: 'chevron-down';
  data: string;
} = {
  name: 'chevron-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.293 9.293a1 1 0 0 1 1.414 0L12 12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z" fill="currentColor"/></svg>`,
};
